import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuthenticatePartnerService } from 'services/authenticatePartner'
import { setUserToken } from 'modules/ApolloClient/utils/storageUserToken'
import { useRedirectTo } from 'hooks/useRedirectTo'
import { ROUTES_PATH } from 'constants/routesPath'

export const PartnerToken = () => {
    const { token } = useParams<{ token: string }>()
    const { getPartnerSignInToken } = useAuthenticatePartnerService()
    const { redirectToPath } = useRedirectTo()

    useEffect(() => {
        const run = async () => {
            if (!token) {
                redirectToPath({
                    defaultRedirect: ROUTES_PATH.SIGN_IN,
                })
                return
            }

            try {
                const response = await getPartnerSignInToken(token)
                const { token: accessToken } = response ?? {}

                if (token) {
                    await setUserToken({ token: accessToken || '', refreshToken: '' })

                    redirectToPath({
                        defaultRedirect: '/plataforma/inicio',
                    })
                } else {
                    redirectToPath({
                        defaultRedirect: ROUTES_PATH.SIGN_IN,
                    })
                }
            } catch (err) {
                console.error('Erro ao buscar token do parceiro:', err)
                redirectToPath({
                    defaultRedirect: ROUTES_PATH.SIGN_IN,
                })
            }
        }

        run()
    }, [token])

    return <div>Redirecionando...</div>
}
